<template>
<CommonHeader></CommonHeader>
<FirstView :createThumbnailBy="createThumbnailBy" :introDisc="intro"></FirstView>
<div class="l-wrapper__sepalate">
  <CaptureTabBlock
    @capture="capture"
    :createThumbnailBy="createThumbnailBy"
    :errorAxios="isAxiosError"
    ></CaptureTabBlock>
  <Afarea></Afarea>
</div>
<Acordion></Acordion>
<transition name="showModal">
<ModalFull
  v-show="handleModal.showModal"
  :loading="handleModal.loading"
  :generated="handleModal.generated"
  :createThumbnailBy="createThumbnailBy">
</ModalFull>
</transition>
<CommonFooter></CommonFooter>
</template>

<script>
import axios from 'axios'
import domtoimage from 'dom-to-image'
import Store from '../store/index.js'
import CommonHeader from '@/components/organisms/CommonHeader.vue'
import CommonFooter from '@/components/organisms/CommonFooter.vue'
import FirstView from '@/components/organisms/FirstView.vue'
import CaptureTabBlock from '@/components/organisms/CaptureTabBlock.vue'
import Afarea from '@/components/modules/Afarea.vue'
import Acordion from '@/components/organisms/QandA.vue'
import ModalFull from '@/components/organisms/ModalFull.vue'

const api = axios.create()

export default {
  name: 'Home',
  components: {
    CommonHeader,
    CommonFooter,
    FirstView,
    CaptureTabBlock,
    Acordion,
    Afarea,
    ModalFull
  },
  props: {
    introDisc: {
      type: Array,
      default () {
        return [
          { msg: 'URL入力、または画像をアップロード' },
          { msg: '背景色を選んだら、ボタンを押すだけ' },
          { msg: '少し待つともう、画像ができています' }
        ]
      }
    },
    pageSpeedApi: {
      type: Object,
      default () {
        return {
          endPoint: 'https://www.googleapis.com/pagespeedonline/v5/runPagespeed?url=',
          optionDesktop: '&screenshot=true&strategy=desktop&key=AIzaSyAanDaBoebV9f81udoulk_7Oib1RmL1KcQ',
          optionMobile: '&screenshot=true&strategy=mobile&key=AIzaSyAanDaBoebV9f81udoulk_7Oib1RmL1KcQ'
        }
      }
    }
  },
  data () {
    return {
      intro: this.introDisc,
      showModal: false,
      error: {
        axios: {
          isError: Store.state.errors.axios.isError,
          msg: Store.state.errors.axios.msg
        }
      }
    }
  },
  computed: {
    createThumbnailBy () {
      let type = String
      Store.state.createThumbnailBy.url ? type = 'url' : type = 'img'
      return type
    },
    handleModal () {
      return {
        showModal: Store.state.modal.showModal,
        loading: Store.state.modal.loading,
        generated: Store.state.modal.generated
      }
    },
    isAxiosError () {
      return Store.state.errors.axios
    }
  },
  methods: {
    capture (e) {
      Store.commit('handleModalLoadingOpen')
      if (Store.state.thumbnailType.p1) {
        switch (true) {
          case Store.state.createThumbnailBy.url:
            this.gererateP1ByUrl()
            Store.commit('handleUrlChangeFlag', false)
            break
          case Store.state.createThumbnailBy.img:
            this.gererateP1ByImg()
            break
          default:
            console.log('createbyerror')
            break
        }
      } else if (Store.state.thumbnailType.p2) {
        switch (true) {
          case Store.state.createThumbnailBy.url:
            this.generateP2ByUrl()
            Store.commit('handleUrlChangeFlag', false)
            break
          case Store.state.createThumbnailBy.img:
            this.generateP2ByImg()
            break
          default:
            console.log('createbyerror')
            break
        }
      }
    },
    gererateP1ByUrl () {
      if (Store.state.urlChangeFlag) {
        axios.all([
          api.get(this.pageSpeedApi.endPoint + Store.state.url + this.pageSpeedApi.optionDesktop),
          api.get(this.pageSpeedApi.endPoint + Store.state.url + this.pageSpeedApi.optionMobile)
        ]).then(([responcePc, responceSp]) => {
          Store.state.screenShot.pc = responcePc.data.lighthouseResult.audits['final-screenshot'].details.data
          Store.state.screenShot.sp = responceSp.data.lighthouseResult.audits['final-screenshot'].details.data
          Store.commit('handleModalTurnGenerated')
          this.domToImage()
        }).catch(error => {
          console.log(error.responce)
          Store.commit('handleAxiosError', true)
          Store.commit('handleBtnError', true)
          Store.commit('handleModalCloseAll')
        })
      } else {
        Store.commit('handleModalTurnGenerated')
        this.domToImage()
      }
    },
    gererateP1ByImg () {
      Store.commit('handleModalTurnGenerated')
      this.domToImage()
    },
    generateP2ByUrl () {
      if (Store.state.urlChangeFlag) {
        axios.all([
          api.get(this.pageSpeedApi.endPoint + Store.state.url + this.pageSpeedApi.optionDesktop),
          api.get(this.pageSpeedApi.endPoint + Store.state.url + this.pageSpeedApi.optionMobile)
        ]).then(([responcePc, responceSp]) => {
          Store.state.screenShot.pc = responcePc.data.lighthouseResult.audits['final-screenshot'].details.data
          Store.state.screenShot.sp = responceSp.data.lighthouseResult.audits['final-screenshot'].details.data
          Store.commit('handleModalTurnGenerated')
          this.domToImage()
        }).catch(error => {
          console.log(error.responce)
          Store.commit('handleAxiosError', true)
          Store.commit('handleBtnError', true)
          Store.commit('handleModalCloseAll')
        })
      } else {
        Store.commit('handleModalTurnGenerated')
        this.domToImage()
      }
    },
    generateP2ByImg () {
      Store.commit('handleModalTurnGenerated')
      this.domToImage()
    },
    domToImage () {
      var node = document.getElementById('generatedAsDom')

      domtoimage.toPng(node).then(function (dataUrl) {
        Store.state.worksThumbnailBase64 = dataUrl
      }).catch(function (error) {
        console.error('oops, something went wrong!', error)
      })
    },
    validation (e) {
    }
  }
}
</script>

<style lang="scss" scoped>
.showModal-enter-from,
.showModal-leave-to{
  opacity: 0;
}
.showModal-enter-active,
.showModal-leave-active {
  transition: opacity .5s;
}
.l-wrapper{
  padding: 20px 50/1280*100vw 20px;

  &__sepalate{
    @extend .l-wrapper;
    display: flex;
    justify-content: space-between;

    @include media-queries-sp {
      display: block;
    }
  }
}
</style>
